import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TaskSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import { view_all_tasks} from '../../../../../cosmosTracking/cosmosEvents'
import holiprizes from '../../../../../assets/images/surprise-card-holi-2026.png'
import giftbox from '../../../../../assets/images/surprise-gift-holi-2026.png'
import holippl from '../../../../../assets/images/holi-people.png';
import ProgressMeter from '../ProgressMeter/ProgressMeterTutor';
import TimerCard from './timerCard/TimerCard';
function TaskSlide(props) {
	const { data } = props;
	console.log("kkkk",data)
	return (
		<div className="slideCard slideCardTask">
			<div className="cardBody">
				{/* <img src={holippl} className='overlay-image' /> */}
				
				<img className="task-top-img" src={holiprizes} alt="task img"/>
				<hr className='leader-board-top-img-border' />
				<div className="revenueData">
					<img
						src={"https://cdn-cp-assets-public.classplus.co/campaigns-assets/ractangle-hprizontal-stand.png"}
						alt="border" height={50} width={4}/>
					<div className='your-revenue-div'>
						<h4>{data?.revenueCard?.text || "Your Revenue"}</h4>
						<h1>{data?.total}</h1>
					</div>
					{data?.endTime[0] && <TimerCard timeMs={data?.endTime[0] ? data?.endTime[0] * 1000 : 0} />}
				</div>
				<div className="meterData">
					<ProgressMeter width={data?.progressBar}/>
				</div>
				<div className="completeData">
					<p>{data?.progressBar}% complete</p>
					<p>Goal: {data?.goal}</p>
				</div>
				
				<div className="taskData">
					<img src={data?.winningPromoImages} alt="box" width='100%' height='100%' />
				</div>
				{/* <CardButton text={'View All Tasks'}
							eventCallback={() => {
								cosmosTrackService(view_all_tasks);
							}}
							className={'btn-action'}
							deeplink={data?.deeplink}
				/> */}
			</div>
		</div>
	);
}

export default TaskSlide;
